import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { eslLinkRoutes } from './esl-link.routes';
import { SOFTLINE_PERMISSION_ESL } from './esl-link.shared';

/**
 * @deprecated use provideEslLinkStorageProviders instead
 */
export const eslLinkProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'eslLink',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#ESL_LINK.TITLE',
      icon: 'fa-regular fa-tags',
      route: '/esl-link/associate',
      permission: SOFTLINE_PERMISSION_ESL,
      group: getModuleGroupByName('Elektronische Etiketten'),
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'ESL-Flash',
      icon: 'fa-regular fa-lightbulb-exclamation-on',
      route: '/esl-link/flash',
      permission: SOFTLINE_PERMISSION_ESL,
      group: getModuleGroupByName('Elektronische Etiketten'),
    });
  }),
];

export function provideEslLinkProviders() {
  return [
    provideSoftAppsModule(
      {
        name: 'esl-link',
        title: '#ESL_LINK.TITLE',
        icon: 'fa-regular fa-tags',
        route: '/esl-link/associate',
        permission: SOFTLINE_PERMISSION_ESL,
        group: getModuleGroupByName('Elektronische Etiketten'),
      },
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleRoutes({ app: eslLinkRoutes }),
      withSoftAppsModuleInfo({
        library: '@softapps/handel/esl-link',
        description: 'Elektronische Etiketten mit Artikeln verknüpfen.',
      })
    ),
    provideSoftAppsModule({
      name: 'ESL-Flash',
      title: 'ESL-Flash',
      icon: 'fa-regular fa-lightbulb-exclamation-on',
      route: '/esl-link/flash',
      permission: SOFTLINE_PERMISSION_ESL,
      group: getModuleGroupByName('Elektronische Etiketten'),
    },
      withSoftAppsModuleInfo({
        library: '@softapps/handel/esl-link',
        description: 'Elektronische Etiketten aufblinken lassen.',
      })
    ),
  ];
}
